<div class="modal-backdrop" (click)="onClose()"></div>
<div class="modal-container">
	<section class="d-f fd-c jc-sb md">
		<div class="pt-xxxs pb-xxxs pr-xxs pl-xxs d-f jc-sb ai-c md__header">
			<h2>Transferir Beneficiário</h2>
			<button mat-icon-button aria-label="Close modal" (click)="onClose()">
				<mat-icon svgIcon="sanus-closeb"></mat-icon>
			</button>
		</div>

		<div class="mt-xxs mb-xxs d-f fd-c jc-fs oy-a md__body no-margins">
			<ng-container *ngIf="isLoading">
				<div class="d-f jc-c ai-c w-100 mt-giant">
					<mat-spinner diameter="20"></mat-spinner>
				</div>
			</ng-container>

			<ng-container *ngIf="!isLoading && !showConfirmation">
				<div class="w-100 h-100 mb-fix container" [formGroup]="form">
					<div class="d-f mt-xxxs ml-xxxs line">
						<mat-form-field
							class="mr-xxxs col-1"
							title="Organização de destino"
							appearance="outline"
						>
							<mat-label>Organização de destino</mat-label>
							<mat-select formControlName="toOrganizationId">
								<mat-option value="" *ngIf="organizations.length > 0">
									Selecione uma organização
								</mat-option>
								<mat-option
									value=""
									disabled
									*ngIf="organizations.length === 0"
								>
									Nenhuma organização disponível no grupo
								</mat-option>
								<mat-option *ngFor="let org of organizations" [value]="org.id">
									{{ org.name_secondary }}
								</mat-option>
							</mat-select>
							<mat-error
								*ngIf="form.get('toOrganizationId')?.hasError('required')"
							>
								Campo obrigatório
							</mat-error>
						</mat-form-field>

						<mat-form-field
							class="mr-xxxs col-1 mob-va"
							title="Tipo de transferência"
							appearance="outline"
						>
							<mat-label>Tipo de transferência</mat-label>
							<mat-select formControlName="transferType">
								<mat-option [value]="transferTypes.IMMEDIATE">
									Transferência imediata
								</mat-option>
								<mat-option [value]="transferTypes.SCHEDULED">
									Agendar transferência
								</mat-option>
							</mat-select>
							<mat-error *ngIf="form.get('transferType')?.hasError('required')">
								Campo obrigatório
							</mat-error>
						</mat-form-field>
					</div>

					<div
						class="d-f ml-xxxs mt-xxs line"
						*ngIf="form.get('transferType')?.value === transferTypes.SCHEDULED"
					>
						<mat-form-field
							class="mr-xxxs col-1"
							title="Data da transferência"
							appearance="outline"
						>
							<mat-label>Data da transferência</mat-label>
							<input
								matInput
								placeholder="Data da transferência"
								formControlName="scheduledDate"
								[matDatepicker]="picker"
								[min]="getMinDate()"
								[max]="getMaxDate()"
							/>
							<mat-datepicker-toggle matSuffix [for]="picker">
								<mat-icon
									matDatepickerToggleIcon
									svgIcon="sanus-calendar-blue"
								></mat-icon>
							</mat-datepicker-toggle>
							<mat-datepicker #picker></mat-datepicker>
							<mat-error
								*ngIf="form.get('scheduledDate')?.hasError('required')"
							>
								Campo obrigatório
							</mat-error>
							<mat-error
								*ngIf="form.get('scheduledDate')?.hasError('dateOutOfRange')"
							>
								A data deve estar entre amanhã e 6 meses a partir de hoje.
							</mat-error>
						</mat-form-field>
					</div>

					<div
						class="warning-box mt-xxs ml-xxxs mr-xxxs"
						*ngIf="showScheduledTransferWarning"
					>
						<mat-icon class="warning-icon">warning</mat-icon>
						<span>
							<strong>Atenção:</strong>
							Já existe uma transferência programada para
							{{ scheduledTransfer?.scheduledDate | date: 'dd/MM/yyyy' }}. Para
							agendar uma nova transferência, você deve primeiro cancelar a
							transferência atual.
						</span>
					</div>

					<div
						class="info-box mt-xxs ml-xxxs mr-xxxs"
						*ngIf="!showScheduledTransferWarning"
					>
						<mat-icon class="info-icon">info</mat-icon>
						<span *ngIf="!hasDependent">
							O beneficiário {{ beneficiaryName }} será transferido para a
							organização selecionada.
						</span>
						<span *ngIf="hasDependent">
							O titular {{ beneficiaryName }} e os dependentes serão
							transferidos juntos.
						</span>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="!isLoading && showConfirmation">
				<div class="w-100 h-100 container">
					<div class="text-center mt-xs">
						<h3 class="mb-xxs">Atenção</h3>

						<div class="warning-box mt-xxs ml-xxxs mr-xxxs">
							<p class="mb-nano">
								<strong>SIM:</strong>
								mantém os benefícios, a numeração das carteirinhas e a vigência.
							</p>
							<p class="mb-0">
								<strong>NÃO:</strong>
								os benefícios serão removidos, incluindo a numeração das
								carteirinhas e a vigência.
							</p>
						</div>

						<div class="d-f jc-c mt-xs">
							<button
								class="p-quark mr-xxs"
								mat-stroked-button
								color="warn"
								(click)="confirmTransfer(false)"
								[disabled]="isLoading"
							>
								<mat-icon class="mr-nano">cancel</mat-icon>
								NÃO
							</button>
							<button
								class="p-quark"
								mat-flat-button
								color="primary"
								(click)="confirmTransfer(true)"
								[disabled]="isLoading"
							>
								<mat-icon class="mr-nano">check_circle</mat-icon>
								SIM
							</button>
						</div>
					</div>
				</div>
			</ng-container>
		</div>

		<div
			class="pt-xxxs pb-xxxs pr-xxs pl-xxs d-f ai-c jc-fe fixed-footer md__footer"
			*ngIf="!showConfirmation"
		>
			<button
				class="p-quark mr-xxs"
				id="close-button"
				mat-stroked-button
				color="primary"
				(click)="onClose()"
			>
				Cancelar
			</button>
			<button
				class="p-quark"
				mat-flat-button
				color="primary"
				[disabled]="form.invalid || isLoading"
				(click)="onSubmit()"
			>
				<span
					*ngIf="form.get('transferType')?.value === transferTypes.IMMEDIATE"
				>
					Transferir agora
				</span>
				<span
					*ngIf="form.get('transferType')?.value === transferTypes.SCHEDULED"
				>
					Agendar Transferência
				</span>
			</button>
		</div>
	</section>
</div>
